"use client";

import { Banner } from "@/components/Banner";
import { Marquee } from "@/components/Marquee";
import { NextImage } from "@/components/NextImage";
import { Typography } from "@/components/Typography";

import { BannerWrapperSize } from "@/components/Banner/types";
import { companiesModuleProps } from "@/data/types/home";

import "./styles.scss";

export const CompaniesModule = ({
  data,
  wrapperSize,
}: {
  data: companiesModuleProps;
  wrapperSize?: BannerWrapperSize;
}) => {
  const { title, subtitle, logos, speed, gap, backgroundColor } = data;

  const defaultSpeed = 40;
  const speedValue = speed ?? defaultSpeed;

  return (
    <Banner
      light
      xsmall
      noCenter
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}
      customClass="companies-module-banner"
    >
      <div
        className="companies-module"
        data-testid="companies-module"
      >
        {(title || subtitle) && (
          <div className="companies-module__header">
            {title && (
              <Typography
                Tag="h2"
                classname="u-text-center u-spacing-0"
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                Tag="p"
                classname="u-text-center"
              >
                {subtitle}
              </Typography>
            )}
          </div>
        )}
        <Marquee
          className="companies-module__marquee"
          speed={speedValue}
          {...(gap != null && { gap })}
          items={logos.map((logo) => (
            <NextImage
              key={logo.src}
              src={logo.src}
              alt={logo.alt}
              width={logo.width ?? 120}
              height={logo.height ?? 40}
              style={{ width: "auto", height: "auto" }}
              loading="lazy"
            />
          ))}
        />
      </div>
    </Banner>
  );
};
